import _clonedeep from 'lodash.clonedeep'

export const SET_CHATWEB_AUTH_TOKEN = 'SET_CHATWEB_AUTH_TOKEN'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_USER_AVAILABLE = 'SET_USER_AVAILABLE'

const initialState = {
  chatwebAuthToken: '',
  authToken: '',
  available: false,
}

export default function user(state = initialState, action) {
  switch (action.type) {
    case SET_CHATWEB_AUTH_TOKEN: {
      const { chatwebAuthToken } = action
      return Object.assign({}, state, { chatwebAuthToken })
    }
    case SET_USER_DATA: {
      const { user } = action
      return _clonedeep({ ...state, ...user })
    }
    case SET_USER_AVAILABLE: {
      const { isAvailable } = action

      return _clonedeep({ ...state, available: isAvailable  })
    }
    default: {
      return state
    }
  }
}
